module.exports = __webpack_public_path__ + "static/media/regenbogen-logo.c29c92d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/regenbogen-logo.jpg
// module id = 726
// module chunks = 0